import { render, staticRenderFns } from "./DBSDetails.vue?vue&type=template&id=5fa78da2&scoped=true&"
import script from "./DBSDetails.vue?vue&type=script&lang=js&"
export * from "./DBSDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa78da2",
  null
  
)

export default component.exports